import { AcaoService } from "../../../services/AcaoService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import AcaoForm from "../../../components/forms/AcaoForm.vue";

export default {
    name: "EditarAcao",
    props: {
        activeModal: {
            default: false,
            type: Boolean,
        }
    },
    components: {
        Breadcrumb,
        AcaoForm,
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Ações',
                disabled: false,
                href: '/acoes',
            },
            {
                text: 'Editar Ação',
                disabled: true
            }
        ],
        acaoData: {},
        loading: false,
    }),
    created() {
        this.carregarAcao(this.$route.params.id);
    },
    methods: {
        async handleSave(formData) {
            try {
                this.loading = true;
                
                // Converter dados do formulário para FormData
                const postData = new FormData();
                postData.append("exercicio", formData.exercicio);
                postData.append("codigo_acao", formData.codigoAcao);
                postData.append("descricao_acao", formData.descricaoAcao);
                postData.append("codigo_sub_acao", formData.codigoSubAcao);
                postData.append("sub_acao_descricao", formData.codigoSubAcao);
                postData.append("codigo_funcao", formData.codigoFuncao);
                postData.append("descricao_funcao", formData.descricaoFuncao);
                postData.append("codigo_sub_funcao", formData.codigoSubFuncao);
                postData.append("descricao_sub_funcao", formData.subAcaoFuncao);
                postData.append("ativo", formData.ativo ? 1 : 0);

                // Atualizar a ação
                const response = await AcaoService.update(this.$route.params.id, postData);
                
                if (response) {
                    // Redirecionar para a listagem
                    this.$router.push('/gerenciar-acoes');
                } else {
                    throw new Error('Erro ao atualizar ação');
                }
            } catch (error) {
                console.error('Erro ao atualizar ação:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },
        
        handleCancel() {
            this.$router.push('/gerenciar-acoes');
        },
        async carregarAcao(id) {
            try {
                const response = await AcaoService.show(id);

                if (response) {
                    const data = response.data;
                    // Passa os dados crus para o AcaoForm via prop initialData
                    this.acaoData = data;
                } else {
                    console.error('Não foi possível carregar os dados da ação.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar os dados da ação:', error);
            }
        }
    }
};
